import { Typography } from '@shipengine/giger';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';

function ParcelMeasures(_ref) {
  let {
    name,
    width,
    height,
    length,
    ...otherProps
  } = _ref;
  const showMeasures = width && height && length;
  return jsxs("div", {
    ...otherProps,
    children: [jsx(Typography, {
      variant: "subtitle2",
      bold: true,
      component: "div",
      children: name
    }), showMeasures && jsxs(Typography, {
      variant: "body1",
      component: "div",
      children: [width, "x", height, "x", length]
    })]
  });
}

export { ParcelMeasures };
//# sourceMappingURL=ParcelMeasures.js.map
